import Vapi from 'vuex-rest-api'
import http from 'src/http/index'
import { beforeRequestReset, createSuccess, deleteSuccess, updateSuccess } from 'components/utils/storeUtils'

const initialState = () => ({
  projects: null,
  project: {},
  onderzoeken: null,
  onderzoek: {},
  rapport_onderzoek: {},
  inventarisatie_assets: null,
  inventarisatie_asset: {},
  inventarisatie_users: null,
  inventarisatie_user: {},
  inventarisatie_organisaties: null,
  inventarisatie_organisatie: {},
  laboratoria: null,
  laboratorium: {},
  onderzoeks_laboratoria: null,
  onderzoeks_laboratorium: {},
  lab_orders: null,
  lab_order: {},
  onderzoek_deskundigen: null,
  plattegrond_tekeningen: null,
  plattegrond_tekening: {},
  tekening_objecten: null,
  tekening_object: {},
  reikwijdte_tekeningen: null,
  reikwijdte_tekening: {},
  reikwijdte_elementen: null,
  reikwijdte_element: {},
  tekening_objecten: null,
  tekening_object: {},
  tekening_object_elementen: null,
  tekening_object_element: {},
  bron_locatie_tekeningen: null,
  bron_locatie_tekening: {},
  bron_locatie_tekening_elementen: null,
  bron_locatie_tekening_element: {},
  onderzoeks_rapporten: null,
  app_client: {},
  app_clients: null,

  asbestos_survey_info: {}
})

const projectDepKeys = [
  'onderzoek',
  'onderzoeks_laboratoria', 'onderzoeks_laboratorium', 'onderzoeks_deskundigen',
  'plattegrond_tekeningen', 'plattegrond_tekening', 'reikwijdte_tekening', 'reikwijdte_tekeningen',
  'reikwijdte_elementen', 'reikwijdte_element', 'bron_locatie_tekeningen', 'bron_locatie_tekening',
  'bron_locatie_tekening_elementen', 'bron_locatie_tekening_element'
]

const onderzoekDepKeys = [
  'onderzoeks_laboratoria', 'onderzoeks_laboratorium', 'onderzoeks_deskundigen',
  'plattegrond_tekeningen', 'plattegrond_tekening', 'reikwijdte_tekening', 'reikwijdte_tekeningen',
  'reikwijdte_elementen', 'reikwijdte_element', 'bron_locatie_tekeningen', 'bron_locatie_tekening',
  'bron_locatie_tekening_elementen', 'bron_locatie_tekening_element'
]

const plattegrondTekeningDepKeys = [
  'bron_locatie_tekeningen', 'bron_locatie_tekening',
  'bron_locatie_tekening_elementen', 'bron_locatie_tekening_element'
]

const reijkwijdteTekeningDepKeys = [
  'reikwijdte_tekening', 'reikwijdte_tekeningen',
  'reikwijdte_elementen', 'reikwijdte_element'
]

const bronTekeningDepKeys = ['bron_locatie_tekening_elementen', 'bron_locatie_tekening_element']

const projectmanagement = new Vapi({
  axios: http.axios,
  baseURL: process.env.API_URL + '/inventarisatie',
  queryParams: true,
  state: initialState()
})
  .get({
    action: 'GET_PROJECT_LIST',
    property: 'projects',
    queryParams: true,
    path: '/project'
  })
  .get({
    action: 'GET_PROJECT',
    property: 'project',
    queryParams: true,
    path: ({ id }) => `/project/${id}`,
    beforeRequest: beforeRequestReset('project', projectDepKeys, initialState())
  })
  .post({
    action: 'CREATE_PROJECT',
    property: 'project',
    path: '/project',
    onSuccess: createSuccess('project', 'projects')
  })
  .post({
    action: 'UPDATE_PROJECT',
    property: 'project',
    path: ({ id }) => `/project/${id}`,
    onSuccess: updateSuccess('project', 'projecten')
  })
  .delete({
    action: 'DELETE_PROJECT',
    property: 'project',
    queryParams: true,
    path: ({ id }) => `/project/${id}`,
    onSuccess: deleteSuccess('project')
  })
  // TODO DEPRECATED
  .get({
    action: 'GET_BRON_LOCATIE_TEKENINGEN_FROM_PLATTEGROND_TEKENING',
    property: 'bron_locatie_tekeningen',
    queryParams: true,
    path: ({ id }) => `/plattegrond_tekening/${id}/bron_locatie_tekeningen`
  })
  .get({
    action: 'GET_BRON_LOCATIE_TEKENING',
    property: 'bron_locatie_tekening',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_tekening/${id}`,
    beforeRequest: beforeRequestReset('bron_locatie_tekening', bronTekeningDepKeys, initialState())
  })
  .post({
    action: 'CREATE_BRON_LOCATIE_TEKENING',
    property: 'bron_locatie_tekening',
    path: '/bron_locatie_tekening',
    queryParams: true,
    onSuccess: createSuccess('bron_locatie_tekening', 'bron_locatie_tekeningen')
  })
  .post({
    action: 'UPDATE_BRON_LOCATIE_TEKENING',
    property: 'bron_locatie_tekening',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_tekening/${id}`,
    onSuccess: updateSuccess('bron_locatie_tekening', 'bron_locatie_tekeningen')
  })
  .delete({
    action: 'DELETE_BRON_LOCATIE_TEKENING',
    property: 'bron_locatie_tekening',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_tekening/${id}`,
    onSuccess: deleteSuccess('bron_locatie_tekening')
  })
  .get({
    action: 'GET_BRON_LOCATIE_TEKENING_ELEMENTEN_FROM_TEKENING',
    property: 'bron_locatie_tekening_elementen',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_tekening/${id}/bron_locatie_tekening_elementen`
  })
  .get({
    action: 'GET_BRON_LOCATIE_TEKENING_ELEMENT',
    property: 'bron_locatie_tekening_element',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_tekening_element/${id}`
  })
  .post({
    action: 'CREATE_BRON_LOCATIE_TEKENING_ELEMENT',
    property: 'bron_locatie_tekening_element',
    path: '/bron_locatie_tekening_element',
    onSuccess: (state, payload) => {
      if (!state.bron_locatie_tekening_elementen) {
        state.bron_locatie_tekening_elementen = []
      }
      state.bron_locatie_tekening_elementen.push(payload.data)
      state.bron_locatie_tekeningen.forEach((tekening) => {
        if (payload.data.bron_locatie_tekening && tekening.id === payload.data.bron_locatie_tekening.id) {
          if (!tekening.bron_locatie_tekening_elementen) {
            tekening.bron_locatie_tekening_elementen = []
          }
          tekening.bron_locatie_tekening_elementen.push(payload.data)
        }
      })
    }
  })
  .post({
    action: 'UPDATE_BRON_LOCATIE_TEKENING_ELEMENT',
    property: 'bron_locatie_tekening_element',
    path: ({ id }) => `/bron_locatie_tekening_element/${id}`,
    onSuccess: updateSuccess('bron_locatie_tekening_element', 'bron_locatie_tekening_elementen')
  })
  .delete({
    action: 'DELETE_BRON_LOCATIE_TEKENING_ELEMENT',
    property: 'bron_locatie_tekening_element',
    queryParams: true,
    path: ({ id }) => `/bron_locatie_tekening_element/${id}`,
    onSuccess: deleteSuccess('bron_locatie_tekening_element')
  })
  .get({
    action: 'GET_TEKENING_OBJECTEN_FROM_PLATTEGROND_TEKENING',
    property: 'tekening_objecten',
    queryParams: true,
    path: ({ id }) => `/plattegrond_tekening/${id}/objecten`
  })
  .get({
    action: 'GET_TEKENING_OBJECT',
    property: 'tekening_object',
    queryParams: true,
    path: ({ id }) => `/plattegrond_tekening_object/${id}`,
    beforeRequest: beforeRequestReset('tekening_object', bronTekeningDepKeys, initialState())
  })
  .post({
    action: 'CREATE_TEKENING_OBJECT',
    property: 'tekening_object',
    path: '/plattegrond_tekening_object',
    queryParams: true,
    onSuccess: createSuccess('tekening_object', 'tekening_objecten')
  })
  .post({
    action: 'UPDATE_TEKENING_OBJECT',
    property: 'tekening_object',
    queryParams: true,
    path: ({ id }) => `/plattegrond_tekening_object/${id}`,
    onSuccess: updateSuccess('tekening_object', 'tekening_objecten')
  })
  .delete({
    action: 'DELETE_TEKENING_OBJECT',
    property: 'tekening_object',
    queryParams: true,
    path: ({ id }) => `/plattegrond_tekening_object/${id}`,
    onSuccess: deleteSuccess('tekening_object')
  })
  .get({
    action: 'GET_TEKENING_OBJECT_ELEMENTEN_FROM_TEKENING',
    property: 'tekening_object_elementen',
    queryParams: true,
    path: ({ id }) => `/plattegrond_tekening_object/${id}/elementen`
  })
  .get({
    action: 'GET_TEKENING_OBJECT_ELEMENT',
    property: 'tekening_object_element',
    queryParams: true,
    path: ({ id }) => `/plattegrond_tekening_obj_element/${id}`
  })
  .post({
    action: 'CREATE_TEKENING_OBJECT_ELEMENT',
    property: 'tekening_object_element',
    path: '/plattegrond_tekening_obj_element',
    onSuccess: updateSuccess('tekening_object_element', 'tekening_object_elementen')
    // (state, payload) => {
    //   if (!state.tekening_object_elementen) {
    //     state.tekening_object_elementen = []
    //   }
    //   state.tekening_object_elementen.push(payload.data)
    //   state.tekening_objecten.forEach((tekening) => {
    //     if (payload.data.tekening_object && tekening.id === payload.data.tekening_object.id) {
    //       if (!tekening.tekening_object_elementen) {
    //         tekening.tekening_object_elementen = []
    //       }
    //       tekening.tekening_object_elementen.push(payload.data)
    //     }
    //   })
    // }
  })
  .post({
    action: 'UPDATE_TEKENING_OBJECT_ELEMENT',
    property: 'tekening_object_element',
    path: ({ id }) => `/plattegrond_tekening_obj_element/${id}`,
    onSuccess: updateSuccess('tekening_object_element', 'tekening_object_elementen')
  })
  .delete({
    action: 'DELETE_TEKENING_OBJECT_ELEMENT',
    property: 'tekening_object_element',
    queryParams: true,
    path: ({ id }) => `/plattegrond_tekening_obj_element/${id}`,
    onSuccess: deleteSuccess('tekening_object_element')
  })
  .get({
    action: 'GET_PLATTEGROND_TEKENINGEN_FROM_ONDERZOEK',
    property: 'plattegrond_tekeningen',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}/inventarisatie_asset/plattegrond_tekeningen`
  })
  .get({
    action: 'GET_PLATTEGROND_TEKENING',
    property: 'plattegrond_tekening',
    queryParams: true,
    path: ({ id }) => `/plattegrond_tekening/${id}`,
    beforeRequest: beforeRequestReset('plattegrond_tekening', plattegrondTekeningDepKeys, initialState())
  })
  .post({
    action: 'CREATE_PLATTEGROND_TEKENING',
    property: 'plattegrond_tekening',
    path: '/plattegrond_tekening',
    onSuccess: createSuccess('plattegrond_tekening', 'plattegrond_tekeningen')
  })
  .post({
    action: 'UPDATE_PLATTEGROND_TEKENING',
    property: 'plattegrond_tekening',
    path: ({ id }) => `/plattegrond_tekening/${id}`,
    onSuccess: updateSuccess('plattegrond_tekening', 'plattegrond_tekeningen')
  })
  .delete({
    action: 'DELETE_PLATTEGROND_TEKENING',
    property: 'plattegrond_tekening',
    queryParams: true,
    path: ({ id }) => `/plattegrond_tekening/${id}`,
    onSuccess: deleteSuccess('plattegrond_tekening')
  })
  .get({
    action: 'GET_TEKENING_OBJECTEN_FROM_TEKENING',
    property: 'tekening_objecten',
    queryParams: true,
    path: ({ id }) => `/plattegrond_tekening/${id}/objecten`
  })
  .get({
    action: 'GET_TEKENING_OBJECT',
    property: 'tekening_object',
    queryParams: true,
    path: ({ id }) => `/plattegrond_tekening_object/${id}`,
    beforeRequest: beforeRequestReset('tekening_object', plattegrondTekeningDepKeys, initialState())
  })
  .post({
    action: 'CREATE_TEKENING_OBJECT',
    property: 'tekening_object',
    path: '/plattegrond_tekening_object',
    onSuccess: createSuccess('tekening_object', 'tekening_objecten')
  })
  .post({
    action: 'UPDATE_TEKENING_OBJECT',
    property: 'tekening_object',
    path: ({ id }) => `/plattegrond_tekening_object/${id}`,
    onSuccess: updateSuccess('tekening_object', 'tekening_objecten')
  })
  .delete({
    action: 'DELETE_TEKENING_OBJECT',
    property: 'tekening_object',
    queryParams: true,
    path: ({ id }) => `/plattegrond_tekening_object/${id}`,
    onSuccess: deleteSuccess('tekening_object')
  })
  .get({
    action: 'GET_REIKWIJDTE_TEKENING_FROM_ONDERZOEK',
    property: 'reikwijdte_tekening',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}/reikwijdte_tekening`,
    onSuccess: (state, payload) => {
      state.reikwijdte_tekening = payload.data[0]
    }
  })
  .get({
    action: 'GET_REIKWIJDTE_TEKENING',
    property: 'reikwijdte_tekening',
    queryParams: true,
    path: ({ id }) => `/reikwijdte_tekening/${id}`,
    beforeRequest: beforeRequestReset('reikwijdte_tekening', reijkwijdteTekeningDepKeys, initialState())
  })
  .post({
    action: 'CREATE_REIKWIJDTE_TEKENING',
    property: 'reikwijdte_tekening',
    path: '/reikwijdte_tekening',
    queryParams: true,
    onSuccess: (state, payload) => {
      state.reikwijdte_tekening = payload.data
    }
  })
  .post({
    action: 'UPDATE_REIKWIJDTE_TEKENING',
    property: 'reikwijdte_tekening',
    queryParams: true,
    path: ({ id }) => `/reikwijdte_tekening/${id}`,
    onSuccess: updateSuccess('reikwijdte_tekening', 'reikwijdte_tekeningen')
  })
  .delete({
    action: 'DELETE_REIKWIJDTE_TEKENING',
    property: 'reikwijdte_tekening',
    queryParams: true,
    path: ({ id }) => `/reikwijdte_tekening/${id}`,
    onSuccess: deleteSuccess('reikwijdte_tekening')
  })
  .get({
    action: 'GET_REIKWIJDTE_ELEMENTEN_FROM_TEKENING',
    property: 'reikwijdte_elementen',
    queryParams: true,
    path: ({ id }) => `/reikwijdte_tekening/${id}/reikwijdte_elementen`
  })
  .get({
    action: 'GET_REIKWIJDTE_ELEMENT',
    property: 'reikwijdte_element',
    queryParams: true,
    path: ({ id }) => `/reikwijdte_element/${id}`
  })
  .post({
    action: 'CREATE_REIKWIJDTE_ELEMENT',
    property: 'reikwijdte_element',
    path: '/reikwijdte_element',
    onSuccess: createSuccess('reikwijdte_element', 'reikwijdte_elementen')
  })
  .post({
    action: 'UPDATE_REIKWIJDTE_ELEMENT',
    property: 'reikwijdte_element',
    path: ({ id }) => `/reikwijdte_element/${id}`,
    onSuccess: updateSuccess('reikwijdte_element', 'reikwijdte_elementen')
  })
  .delete({
    action: 'DELETE_REIKWIJDTE_ELEMENT',
    property: 'reikwijdte_element',
    queryParams: true,
    path: ({ id }) => `/reikwijdte_element/${id}`,
    onSuccess: deleteSuccess('reikwijdte_element')
  })
  .get({
    action: 'GET_ONDERZOEKEN',
    property: 'onderzoeken',
    queryParams: true,
    path: ({ projectId }) => {
      if (projectId) {
        return `/project/${projectId}/onderzoeken`
      }
      else {
        return '/onderzoek'
      }
    }
  })

  .get({
    action: 'GET_ONDERZOEK',
    property: 'onderzoek',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}`,
    beforeRequest: beforeRequestReset(false, onderzoekDepKeys, initialState())
  })
  .get({
    action: 'GET_RAPPORT_ONDERZOEK',
    property: 'rapport_onderzoek',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}`
  })
  .post({
    action: 'CREATE_ONDERZOEK',
    property: 'onderzoek',
    path: '/onderzoek',
    onSuccess: createSuccess('onderzoek', 'onderzoeken')
  })
  .post({
    action: 'UPDATE_ONDERZOEK',
    property: 'onderzoek',
    path: ({ id }) => `/onderzoek/${id}`,
    onSuccess: updateSuccess('onderzoek', 'onderzoeken')
  })
  .delete({
    action: 'DELETE_ONDERZOEK',
    property: 'onderzoek',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}`,
    onSuccess: deleteSuccess('onderzoek')
  })
  .get({
    action: 'GET_ASBESTOS_SURVEY_INFO',
    property: 'asbestos_survey_info',
    queryParams: true,
    path: ({ id }) => `/asbestos_survey_info/${id}`
  })
  .post({
    action: 'CREATE_ASBESTOS_SURVEY_INFO',
    property: 'asbestos_survey_info',
    path: '/asbestos_survey_info'
  })
  .post({
    action: 'UPDATE_ASBESTOS_SURVEY_INFO',
    property: 'asbestos_survey_info',
    path: ({ id }) => `/asbestos_survey_info/${id}`
  })
  .delete({
    action: 'DELETE_ASBESTOS_SURVEY_INFO',
    property: 'asbestos_survey_info',
    queryParams: true,
    path: ({ id }) => `/asbestos_survey_info/${id}`,
    onSuccess: deleteSuccess('asbestos_survey_info')
  })
  .get({
    action: 'GET_RAPPORTEN_FROM_ONDERZOEK',
    property: 'onderzoeks_rapporten',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}/rapporten`
  })
  .get({
    action: 'GET_DESKUNDIGEN_FROM_ONDERZOEK',
    property: 'onderzoek_deskundigen',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}/inventarisaties/inventarisatie_user`
  })
  .get({
    action: 'GET_PLATTEGRONDEN_FROM_ONDERZOEK',
    property: 'onderzoek_plattegronden',
    queryParams: true,
    path: ({ id }) => `/onderzoek/${id}/plattegrond_tekeningen`
  })
  .get({
    action: 'GET_INVENTARISATIE_ASSETS',
    property: 'inventarisatie_assets',
    queryParams: true,
    path: '/inventarisatie_asset?include=asset'
  })
  .get({
    action: 'GET_INVENTARISATIE_ASSET',
    property: 'inventarisatie_asset',
    queryParams: true,
    path: ({ id }) => `/inventarisatie_asset/${id}`
  })
  .post({
    action: 'CREATE_INVENTARISATIE_ASSET',
    property: 'inventarisatie_asset',
    path: '/inventarisatie_asset',
    onSuccess: createSuccess('inventarisatie_asset', 'inventarisatie_assets')
  })
  .post({
    action: 'UPDATE_INVENTARISATIE_ASSET',
    property: 'inventarisatie_asset',
    path: ({ id }) => `/inventarisatie_asset/${id}`,
    onSuccess: updateSuccess('inventarisatie_asset', 'inventarisatie_assets')
  })
  .delete({
    action: 'DELETE_INVENTARISATIE_ASSET',
    property: 'inventarisatie_asset',
    queryParams: true,
    path: ({ id }) => `/inventarisatie_asset/${id}`,
    onSuccess: deleteSuccess('inventarisatie_asset')
  })
  .get({
    action: 'GET_INVENTARISATIE_USERS',
    queryParams: true,
    property: 'inventarisatie_users',
    path: '/inventarisatie_user'
  })
  .get({
    action: 'GET_INVENTARISATIE_USER',
    property: 'inventarisatie_user',
    queryParams: true,
    path: ({ id }) => `/inventarisatie_user/${id}`
  })
  .post({
    action: 'CREATE_INVENTARISATIE_USER',
    property: 'inventarisatie_user',
    path: '/inventarisatie_user',
    onSuccess: createSuccess('inventarisatie_user', 'inventarisatie_users')
  })
  .post({
    action: 'UPDATE_INVENTARISATIE_USER',
    property: 'inventarisatie_user',
    path: ({ id }) => `/inventarisatie_user/${id}`,
    onSuccess: updateSuccess('inventarisatie_user', 'inventarisatie_users')
  })
  .delete({
    action: 'DELETE_INVENTARISATIE_USER',
    property: 'inventarisatie_user',
    queryParams: true,
    path: ({ id }) => `/inventarisatie_user/${id}`,
    onSuccess: deleteSuccess('inventarisatie_user')
  })
  .get({
    action: 'GET_INVENTARISATIE_ORGANISATIES',
    queryParams: true,
    property: 'inventarisatie_organisaties',
    path: '/inventarisatie_organisatie'
  })
  .get({
    action: 'GET_INVENTARISATIE_ORGANISATIE',
    property: 'inventarisatie_organisatie',
    queryParams: true,
    path: ({ id }) => `/inventarisatie_organisatie/${id}`
  })
  .post({
    action: 'CREATE_INVENTARISATIE_ORGANISATIE',
    property: 'inventarisatie_organisatie',
    path: '/inventarisatie_organisatie',
    onSuccess: createSuccess('inventarisatie_organisatie', 'inventarisatie_organisaties')
  })
  .post({
    action: 'UPDATE_INVENTARISATIE_ORGANISATIE',
    property: 'inventarisatie_organisatie',
    path: ({ id }) => `/inventarisatie_organisatie/${id}`,
    onSuccess: updateSuccess('inventarisatie_organisatie', 'inventarisatie_organisaties')
  })
  .delete({
    action: 'DELETE_INVENTARISATIE_ORGANISATIE',
    property: 'inventarisatie_organisatie',
    queryParams: true,
    path: ({ id }) => `/inventarisatie_organisatie/${id}`,
    onSuccess: deleteSuccess('inventarisatie_organisatie')
  })
  .get({
    action: 'GET_ONDERZOEKS_LABORATORIA',
    property: 'onderzoeks_laboratoria',
    queryParams: true,
    path: ({ id }) => `onderzoek/${id}/onderzoeks_laboratoria`
  })
  .get({
    action: 'GET_ONDERZOEKS_LABORATORIUM',
    property: 'onderzoeks_laboratorium',
    queryParams: true,
    path: ({ id }) => `/onderzoeks_laboratorium/${id}`
  })
  .post({
    action: 'CREATE_ONDERZOEKS_LABORATORIUM',
    property: 'onderzoeks_laboratorium',
    path: '/onderzoeks_laboratorium',
    onSuccess: createSuccess('onderzoeks_laboratorium', 'onderzoeks_laboratoria')
  })
  .post({
    action: 'UPDATE_ONDERZOEKS_LABORATORIUM',
    property: 'onderzoeks_laboratorium',
    path: ({ id }) => `/onderzoeks_laboratorium/${id}`,
    onSuccess: updateSuccess('onderzoeks_laboratorium', 'onderzoeks_laboratoria')
  })
  .delete({
    action: 'DELETE_ONDERZOEKS_LABORATORIUM',
    property: 'onderzoeks_laboratorium',
    queryParams: true,
    path: ({ id }) => `/onderzoeks_laboratorium/${id}`,
    onSuccess: deleteSuccess('onderzoeks_laboratorium')
  })
  .get({
    action: 'GET_LABORATORIA',
    property: 'laboratoria',
    path: '/laboratorium'
  })
  .get({
    action: 'GET_LABORATORIUM',
    property: 'laboratorium',
    queryParams: true,
    path: ({ id }) => `/laboratorium/${id}`
  })
  .post({
    action: 'CREATE_LABORATORIUM',
    property: 'laboratorium',
    path: '/laboratorium',
    onSuccess: createSuccess('laboratorium', 'laboratoria')
  })
  .post({
    action: 'UPDATE_LABORATORIUM',
    property: 'laboratorium',
    path: ({ id }) => `/laboratorium/${id}`,
    onSuccess: updateSuccess('laboratorium', 'laboratoria')
  })
  .delete({
    action: 'DELETE_LABORATORIUM',
    property: 'laboratorium',
    queryParams: true,
    path: ({ id }) => `/laboratorium/${id}`,
    onSuccess: deleteSuccess('laboratorium')
  })
  .get({
    action: 'GET_LAB_ORDERS',
    property: 'lab_orders',
    queryParams: true,
    path: ({ id }) => `onderzoek/${id}/onderzoeks_laboratoria/lab_orders`,
    beforeRequest: beforeRequestReset('lab_order', ['lab_order'], initialState())
  })
  .get({
    action: 'GET_LAB_ORDERS_FROM_ONDERZOEKS_LABORATORIUM',
    property: 'lab_orders',
    queryParams: true,
    path: ({ id }) => `onderzoeks_laboratorium/${id}/lab_orders`,
    beforeRequest: beforeRequestReset('lab_order', ['lab_order'], initialState())
  })
  .get({
    action: 'GET_LAB_ORDER',
    property: 'lab_order',
    queryParams: true,
    path: ({ id }) => `/lab_order/${id}`
  })
  .post({
    action: 'CREATE_LAB_ORDER',
    property: 'lab_order',
    path: '/lab_order',
    onSuccess: createSuccess('lab_order', 'lab_orders')
  })
  .post({
    action: 'UPDATE_LAB_ORDER',
    property: 'lab_order',
    path: ({ id }) => `/lab_order/${id}`,
    onSuccess: updateSuccess('lab_order', 'lab_orders')
  })
  .delete({
    action: 'DELETE_LAB_ORDER',
    property: 'lab_order',
    queryParams: true,
    path: ({ id }) => `/lab_order/${id}`,
    onSuccess: deleteSuccess('lab_order')
  })
  .get({
    action: 'CHECK_LAB_ORDER',
    property: 'lab_order',
    path: ({ id }) => `/lab_order/${id}/check`,
    onSuccess: updateSuccess('lab_order', 'lab_orders')
  })
  .get({
    action: 'SEND_LAB_ORDER',
    property: 'lab_order',
    path: ({ id }) => `/lab_order/${id}/send`,
    onSuccess: updateSuccess('lab_order', 'lab_orders')
  })
  .post({
    action: 'CREATE_ANALYSE_MOGELIJKHEID',
    property: 'analyse_mogelijkheid',
    path: '/laboratorium_analyse_mogelijkheid',
    onSuccess: createSuccess('analyse_mogelijkheid', 'analyse_mogelijkheden')
  })
  .delete({
    action: 'DELETE_ANALYSE_MOGELIJKHEID',
    property: 'analyse_mogelijkheid',
    queryParams: true,
    path: ({ id }) => `/laboratorium_analyse_mogelijkheid/${id}`,
    onSuccess: deleteSuccess('analyse_mogelijkheid', 'analyse_mogelijkheden')
  })
  .get({
    action: 'GET_APP_CLIENTS',
    queryParams: true,
    property: 'app_clients',
    path: '/app_client'
  })
  .get({
    action: 'GET_APP_CLIENT',
    property: 'app_client',
    queryParams: true,
    path: ({ id }) => `/app_client/${id}`
  })
  .post({
    action: 'CREATE_APP_CLIENT',
    property: 'app_client',
    path: '/app_client',
    onSuccess: createSuccess('app_client', 'app_clients')
  })
  .post({
    action: 'UPDATE_APP_CLIENT',
    property: 'app_client',
    path: ({ id }) => `/app_client/${id}`,
    onSuccess: updateSuccess('app_client', 'app_clients')
  })
  .delete({
    action: 'DELETE_APP_CLIENT',
    property: 'app_client',
    queryParams: true,
    path: ({ id }) => `/app_client/${id}`,
    onSuccess: deleteSuccess('app_client')
  })
  .get({
    action: 'GET_LAB_KOPPELINGEN',
    property: 'lab_koppelingen',
    path: '/lab_koppeling',
    beforeRequest: beforeRequestReset('lab_koppeling', ['lab_koppeling'], initialState())
  })
  .getStore()

projectmanagement.mutations.RESET_PROJECTMANAGEMENT_STATE = (state) => {
  const initial = initialState()
  for (const key in initial) {
    if (Object.prototype.hasOwnProperty.call(initial, key)) {
      state[key] = initial[key]
    }
  }
}

export default projectmanagement
